import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputSize } from "./";

interface IProperties
{
    icon: string;
    isDisabled?: boolean;
    title?: string;
    size?: InputSize;
    onClick?: () => void;
}

export class InputSideButton extends React.Component<IProperties>
{
    render()
    {
        const className: string[] = ["side-btn", (this.props.size == InputSize.normal) ? "side-btn--normal" : "", (this.props.isDisabled) ? "side-btn--disabled" : ""]
        const iconClassName: string[] = ["mdi", "mdi-" + this.props.icon]

        return (
            <div
                className={className.join(" ")}
                onClick={this.props.onClick}
                title={this.props.title}>
                <i className={iconClassName.join(" ")}></i>
            </div>
        );
    }
}